import './GearLinkSection.scss';
import { Link } from 'react-router-dom';
import { SettingOutlined } from '@ant-design/icons';
import React from 'react';
export const GearLinkSection = ({ children, route }) => React.createElement("div", { className: 'gear-link-section' },
    children,
    React.createElement(Link, { to: route !== null && route !== void 0 ? route : '' },
        React.createElement(SettingOutlined, null)));
